var convertMinsToHrsMins = function (mins) {
    var h = Math.floor(mins / 60);
    var m = Math.floor(mins % 60);
    var s = Math.floor(((mins % 60) - m) * 60);
    var hour = h < 10 ? "0" + h : h;
    var min = m < 10 ? "0" + m : m;
    return "".concat(hour, "h ").concat(!!min ? "".concat(min, "min") : "", " ").concat(s ? "".concat(s, "sec") : "");
};
export default convertMinsToHrsMins;
//# sourceMappingURL=convertMinsToHrsMins.js.map